import { Platform, StyleSheet } from 'react-native';
import { FOCUS_COLOR } from 'src/theme-v2/focus';
import { brand, neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10,

    height: '100%',
    borderRadius: 16,
    paddingHorizontal: 20,
  },
  buttonZoom: {
    borderWidth: 2,
    borderColor: 'transparent',
  },
  buttonZoomFocus: {
    borderColor: FOCUS_COLOR,
  },
  icon: {
    width: 20,
    height: 20,
    color: neutrals.neutralGrays.graphite,
  },
  hoverTextContainer: {
    position: 'absolute',
    bottom: 30, // Posizionato sopra l'icona
    left: 0,
    backgroundColor: neutrals.white,
    zIndex: 100,
    borderRadius: 8,
    justifyContent: 'center',
    paddingHorizontal: 12,
    paddingVertical: 6,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    alignItems: 'center',
  },
  hoverTextContainerRight: {
    position: 'absolute',
    bottom: 30, // Posizionato sopra l'icona
    right: 0,
    backgroundColor: neutrals.white,
    zIndex: 100,
    borderRadius: 8,
    justifyContent: 'center',
    paddingHorizontal: 12,
    paddingVertical: 6,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    alignItems: 'center',
  },
  hoverText: {
    color: neutrals.black,
    fontSize: 12,
    lineHeight: 15.6, //12* 130%
    fontWeight: '700',
    ...Platform.select({
      web: {
        whiteSpace: 'nowrap' as any,
      },
    }),
  },
});
